import React from 'react';
import PropTypes from 'prop-types';
import {
  PageTitleContainer,
  ContentsWrapper,
  Title,
} from './styles/PageTitleStyles';

/**
 * 各ページのタイトルを表示するコンポーネント
 * @param {string} title - タイトル
 * @param {node} children - タイトル以外の表示する要素
 * @returns
 */
const PageTitle = ({ title, children }) => (
  <PageTitleContainer>
    <ContentsWrapper>
      <Title>{title}</Title>
      {children}
    </ContentsWrapper>
  </PageTitleContainer>
);

PageTitle.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};

PageTitle.defaultProps = {
  children: null,
};

export default PageTitle;
